<ul class="wrp">
    <ng-container *ngFor="let sn of column.menus;let k=index">
        @if(sn.isItem) {
        @if(sn.image?.length > 0) {
        <li multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="menuItem">
            <a multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" [href]="sn?.link" class="w100 item hlink">
                <div class="menuimgwrp">
                    <div class="menuimgbody">
                        <img class="imgmenu" [src]="sn.image" alt="img">
                    </div>
                    <div class="menuinputwrp">
                        <span multilang [defaultlanguage]="partner?.defaultLanguage || 'de'"
                            class="menuinputwrpspan">{{sn.title}}</span>
                        <p multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="menuinputwrpp">
                            {{sn.subtitle}}</p>
                    </div>
                </div>
            </a>
        </li>
        } @else {
        <li multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="menuItem">
            <a multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" [href]="sn?.link"
                class="w100 item hlink">{{sn.title}}</a>
        </li>
        }

        } @else {
        <li multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="repwrp">
            <div class="rephwrp">
                <a multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" [href]="sn?.link"
                    class="rep hlink">{{sn?.title}}</a>
            </div>
            <ul class="rephwrpsub">
                <ng-container *ngFor="let subsn of sn.menus">

                    @if(subsn.image?.length > 0) {
                    <li multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="menuItem">
                        <a multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" [href]="subsn?.link"
                            class="w100 item hlink">
                            <div class="menuimgwrp">
                                <div class="menuimgbody">
                                    <img class="imgmenu" [src]="subsn.image" alt="img">
                                </div>
                                <div class="menuinputwrp">
                                    <span multilang [defaultlanguage]="partner?.defaultLanguage || 'de'"
                                        class="menuinputwrpspan">{{subsn.title}}</span>
                                    <p multilang [defaultlanguage]="partner?.defaultLanguage || 'de'"
                                        class="menuinputwrpp">{{subsn.subtitle}}</p>
                                </div>
                            </div>
                        </a>
                    </li>
                    } @else {
                    <li multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" class="menuItem">
                        <a multilang [defaultlanguage]="partner?.defaultLanguage || 'de'" [href]="subsn?.link"
                            class="w100 item hlink">{{subsn.title}}</a>
                    </li>
                    }
                </ng-container>
            </ul>
        </li>
        }
    </ng-container>
</ul>